






















import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import Connection from '@/api/models/Connection';
import { getBrandKey, isSimla, getHost } from '@/components/helper';

@Component
export default class Layout extends Vue {
    get docLink(): string {
        return isSimla(this.currentConnection)
            ? 'https://docs.simla.com'
            : 'https://docs.retailcrm.ru/Users/Integration/DeliveryServices/sdeknew';
    }

    get brand(): string {
        return getBrandKey(this.currentConnection);
    }

    get logoSrcHost(): string {
        return getHost(this.currentConnection)
    }

    @Getter('currentConnection')
    private currentConnection: Connection

    @Getter('isLoading')
    readonly loading!: boolean
}
